module.exports = __webpack_public_path__ + "img/hm-logo.1d9eda4a.png";